import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { POST_LOGIN_REDIRECT_KEY, sanitizeReturnPath } from '../_helpers/safeRedirect.js';

/**
 * Route guard for the account pages (ENG-499): /home, /profile, /history,
 * /achievements and /notifications. Signed out, they used to fire their API
 * calls anyway and show a load failure (/profile asked for
 * `/user/profile/null`). Without a session this sends the visitor to /login
 * instead, and saves the page they asked for so OAuthPage brings them back
 * to it after signing in.
 *
 * Used as a layout route, it renders the matched child through <Outlet />;
 * given children, it renders those.
 */
const RequireAuth = ({ children }) => {
  const location = useLocation();
  const signedIn = Boolean(sessionStorage.getItem('jwt'));

  useEffect(() => {
    if (signedIn) return;
    const returnPath = sanitizeReturnPath(location.pathname + location.search + location.hash);
    if (returnPath) sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, returnPath);
  }, [signedIn, location.pathname, location.search, location.hash]);

  if (!signedIn) return <Navigate to="/login" replace />;
  return children ?? <Outlet />;
};

export default RequireAuth;
